import { render, staticRenderFns } from "./OrdenCompra.vue?vue&type=template&id=2e1bebed&scoped=true"
import script from "./OrdenCompra.vue?vue&type=script&lang=js"
export * from "./OrdenCompra.vue?vue&type=script&lang=js"
import style0 from "./OrdenCompra.vue?vue&type=style&index=0&id=2e1bebed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1bebed",
  null
  
)

export default component.exports